export enum QueryKeysEnum {
  Device = "Device",
  DeviceList = "DeviceList",
  Installation = "Installation",
  InstallationList = "InstallationList",
  Account = "Account",
  AccountList = "AccountList",
  LanguageList = "LanguageList",
  ProductsForAccount = "ProductsForAccount",
}
